import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Topic moderator invitation load

export const TOPIC_MODERATOR_INVITATION_FETCH_TRIGGER = 'TOPIC_MODERATOR_INVITATION_FETCH_TRIGGER';
export interface TopicModeratorInvitationFetchTriggerAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_FETCH_TRIGGER;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_MODERATOR_INVITATION_FETCH_REQUEST = 'TOPIC_MODERATOR_INVITATION_FETCH_REQUEST';
export interface TopicModeratorInvitationFetchRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_FETCH_REQUEST;
    readonly topicSlug: string;
    readonly username: string;
}
export interface TopicModeratorInvitationFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; topicModeratorInvitation: number; };
}
export const TOPIC_MODERATOR_INVITATION_FETCH_SUCCESS = 'TOPIC_MODERATOR_INVITATION_FETCH_SUCCESS';
export interface TopicModeratorInvitationFetchSuccessAction extends APISuccessAction<TopicModeratorInvitationFetchNormalizedResponse> {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_FETCH_SUCCESS;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_MODERATOR_INVITATION_FETCH_FAILURE = 'TOPIC_MODERATOR_INVITATION_FETCH_FAILURE';
export interface TopicModeratorInvitationFetchFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_FETCH_FAILURE;
    readonly topicSlug: string;
    readonly username: string;
}

export const topicModeratorInvitationFetchTrigger =
    (topicSlug: string, username: string): TopicModeratorInvitationFetchTriggerAction => ({
        type: TOPIC_MODERATOR_INVITATION_FETCH_TRIGGER, topicSlug, username,
    });
export const topicModeratorInvitationFetchApi = {
    request: (topicSlug: string, username: string): TopicModeratorInvitationFetchRequestAction => ({
        type: TOPIC_MODERATOR_INVITATION_FETCH_REQUEST, topicSlug, username,
    }),
    success: (topicSlug: string, username: string, response: TopicModeratorInvitationFetchNormalizedResponse): TopicModeratorInvitationFetchSuccessAction => ({
        type: TOPIC_MODERATOR_INVITATION_FETCH_SUCCESS, topicSlug, username, response,
    }),
    failure: (topicSlug: string, username: string, error: any): TopicModeratorInvitationFetchFailureAction => ({
        type: TOPIC_MODERATOR_INVITATION_FETCH_FAILURE, topicSlug, username, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Topic moderator invitation accept

export const TOPIC_MODERATOR_INVITATION_ACCEPT_TRIGGER = 'TOPIC_MODERATOR_INVITATION_ACCEPT_TRIGGER';
export interface TopicModeratorInvitationAcceptTriggerAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_ACCEPT_TRIGGER;
    readonly topicModeratorInvitationId: number;
}
export const TOPIC_MODERATOR_INVITATION_ACCEPT_REQUEST = 'TOPIC_MODERATOR_INVITATION_ACCEPT_REQUEST';
export interface TopicModeratorInvitationAcceptRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_ACCEPT_REQUEST;
    readonly topicModeratorInvitationId: number;
}
export interface TopicModeratorInvitationAcceptNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; topicModeratorInvitation: number; };
}
export const TOPIC_MODERATOR_INVITATION_ACCEPT_SUCCESS = 'TOPIC_MODERATOR_INVITATION_ACCEPT_SUCCESS';
export interface TopicModeratorInvitationAcceptSuccessAction extends APISuccessAction<TopicModeratorInvitationAcceptNormalizedResponse> {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_ACCEPT_SUCCESS;
    readonly topicModeratorInvitationId: number;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_MODERATOR_INVITATION_ACCEPT_FAILURE = 'TOPIC_INVITATION_MODERATOR_ACCEPT_FAILURE';
export interface TopicModeratorInvitationAcceptFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_ACCEPT_FAILURE;
    readonly topicModeratorInvitationId: number;
}

export const topicModeratorInvitationAcceptTrigger =
    (topicModeratorInvitationId: number): TopicModeratorInvitationAcceptTriggerAction => ({
        type: TOPIC_MODERATOR_INVITATION_ACCEPT_TRIGGER, topicModeratorInvitationId,
    });
export const topicModeratorInvitationAcceptApi = {
    request: (topicModeratorInvitationId: number): TopicModeratorInvitationAcceptRequestAction => ({
        type: TOPIC_MODERATOR_INVITATION_ACCEPT_REQUEST, topicModeratorInvitationId,
    }),
    success: (topicModeratorInvitationId: number, topicSlug: string, username: string, response: TopicModeratorInvitationAcceptNormalizedResponse): TopicModeratorInvitationAcceptSuccessAction => ({
        type: TOPIC_MODERATOR_INVITATION_ACCEPT_SUCCESS, topicModeratorInvitationId, topicSlug, username, response,
    }),
    failure: (topicModeratorInvitationId: number, error: any): TopicModeratorInvitationAcceptFailureAction => ({
        type: TOPIC_MODERATOR_INVITATION_ACCEPT_FAILURE, topicModeratorInvitationId, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Topic moderator invitation decline

export const TOPIC_MODERATOR_INVITATION_DECLINE_TRIGGER = 'TOPIC_MODERATOR_INVITATION_DECLINE_TRIGGER';
export interface TopicModeratorInvitationDeclineTriggerAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_DECLINE_TRIGGER;
    readonly topicModeratorInvitationId: number;
}
export const TOPIC_MODERATOR_INVITATION_DECLINE_REQUEST = 'TOPIC_MODERATOR_INVITATION_DECLINE_REQUEST';
export interface TopicModeratorInvitationDeclineRequestAction extends APIRequestAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_DECLINE_REQUEST;
    readonly topicModeratorInvitationId: number;
}
export interface TopicModeratorInvitationDeclineNormalizedResponse extends NormalizedResponse {
    readonly result: { topic: number; topicModeratorInvitation: number; };
}
export const TOPIC_MODERATOR_INVITATION_DECLINE_SUCCESS = 'TOPIC_MODERATOR_INVITATION_DECLINE_SUCCESS';
export interface TopicModeratorInvitationDeclineSuccessAction extends APISuccessAction<TopicModeratorInvitationDeclineNormalizedResponse> {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_DECLINE_SUCCESS;
    readonly topicModeratorInvitationId: number;
    readonly topicSlug: string;
    readonly username: string;
}
export const TOPIC_MODERATOR_INVITATION_DECLINE_FAILURE = 'TOPIC_INVITATION_MODERATOR_DECLINE_FAILURE';
export interface TopicModeratorInvitationDeclineFailureAction extends APIFailureAction {
    readonly type: typeof TOPIC_MODERATOR_INVITATION_DECLINE_FAILURE;
    readonly topicModeratorInvitationId: number;
}

export const topicModeratorInvitationDeclineTrigger =
    (topicModeratorInvitationId: number): TopicModeratorInvitationDeclineTriggerAction => ({
        type: TOPIC_MODERATOR_INVITATION_DECLINE_TRIGGER, topicModeratorInvitationId,
    });
export const topicModeratorInvitationDeclineApi = {
    request: (topicModeratorInvitationId: number): TopicModeratorInvitationDeclineRequestAction => ({
        type: TOPIC_MODERATOR_INVITATION_DECLINE_REQUEST, topicModeratorInvitationId,
    }),
    success: (topicModeratorInvitationId: number, topicSlug: string, username: string, response: TopicModeratorInvitationDeclineNormalizedResponse): TopicModeratorInvitationDeclineSuccessAction => ({
        type: TOPIC_MODERATOR_INVITATION_DECLINE_SUCCESS, topicModeratorInvitationId, topicSlug, username, response,
    }),
    failure: (topicModeratorInvitationId: number, error: any): TopicModeratorInvitationDeclineFailureAction => ({
        type: TOPIC_MODERATOR_INVITATION_DECLINE_FAILURE, topicModeratorInvitationId, error,
    }),
};
